/* Chollazo — theme.js (sin dependencias) */
(() => {
  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => Array.from(c.querySelectorAll(s));
  const E = window.Chollazo || {};
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Formato de moneda ---------- */
  const formatMoney = (cents) => {
    const fmt = E.moneyFormat || '{{amount_with_comma_separator}} €';
    const n = (cents / 100).toFixed(2);
    const [i, d] = n.split('.');
    const withSep = (sep, dec) => i.replace(/\B(?=(\d{3})+(?!\d))/g, sep) + dec + d;
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => {
      switch (k) {
        case 'amount_with_comma_separator': return withSep('.', ',');
        case 'amount_no_decimals_with_comma_separator': return i.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
        case 'amount_no_decimals': return i.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        default: return withSep(',', '.');
      }
    });
  };
  E.formatMoney = formatMoney;

  /* ---------- Animaciones de entrada ---------- */
  const initReveal = (root = document) => {
    const els = $$('.reveal, .reveal-img', root).filter((el) => !el.classList.contains('is-visible'));
    if (!('IntersectionObserver' in window) || reduceMotion) { els.forEach((el) => el.classList.add('is-visible')); return; }
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => { if (e.isIntersecting) { e.target.classList.add('is-visible'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach((el) => io.observe(el));
  };

  /* ---------- Header ---------- */
  const header = $('.header');
  if (header) {
    const onScroll = () => header.classList.toggle('is-scrolled', window.scrollY > 8);
    onScroll(); window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ---------- Parallax suave ---------- */
  const parallax = $$('[data-parallax] img');
  if (parallax.length && !reduceMotion) {
    let ticking = false;
    const run = () => {
      parallax.forEach((img) => {
        const r = img.parentElement.getBoundingClientRect();
        if (r.bottom < 0 || r.top > innerHeight) return;
        const p = (r.top + r.height / 2 - innerHeight / 2) / innerHeight;
        img.style.transform = `translate3d(0, ${p * -40}px, 0) scale(1.12)`;
      });
      ticking = false;
    };
    window.addEventListener('scroll', () => { if (!ticking) { requestAnimationFrame(run); ticking = true; } }, { passive: true });
    run();
  }

  /* ---------- Drawers ---------- */
  let lastFocus;
  const openDrawer = (id) => {
    const d = document.getElementById(id); if (!d) return;
    lastFocus = document.activeElement;
    d.classList.add('is-open'); d.setAttribute('aria-hidden', 'false');
    document.body.classList.add('is-locked');
    setTimeout(() => { const f = $('[data-autofocus], button, a, input', d.querySelector('.drawer__panel, .search-modal__panel') || d); f && f.focus({ preventScroll: true }); }, 80);
  };
  const closeDrawer = (d) => {
    d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true');
    if (!$('.drawer.is-open, .search-modal.is-open')) document.body.classList.remove('is-locked');
    lastFocus && lastFocus.focus && lastFocus.focus({ preventScroll: true });
  };
  document.addEventListener('click', (e) => {
    // Solo botones/enlaces propios: apps (p. ej. el formulario COD) también usan data-open
    const opener = e.target.closest('button[data-open], a[data-open]');
    if (opener && document.getElementById(opener.dataset.open)) {
      e.preventDefault(); openDrawer(opener.dataset.open); return;
    }
    const closer = e.target.closest('.drawer [data-close], .search-modal [data-close]');
    if (closer) { e.preventDefault(); closeDrawer(closer.closest('.drawer, .search-modal')); }
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') $$('.drawer.is-open, .search-modal.is-open').forEach(closeDrawer);
  });

  // Sin carrito: cada pedido es de un solo producto. "Pedir ahora" (y cualquier envío del formulario de producto)
  // abre el formulario de pago al recibir (assets/nvnu-cod.js); nunca se añade nada al carrito de Shopify.
  const openCod = (form) => document.dispatchEvent(new CustomEvent('nvnu:open', { detail: { variantId: new FormData(form).get('id') } }));
  document.addEventListener('submit', (e) => {
    const form = e.target.closest('form[data-product-form]');
    if (!form) return;
    e.preventDefault();
    openCod(form);
  });
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-buy-now]');
    if (!btn || btn.disabled) return;
    openCod(btn.closest('form[data-product-form]'));
  });

  /* ---------- Producto ---------- */
  const initProduct = (root) => {
    const dataEl = $('[data-product-json]', root);
    if (!dataEl) return;
    const product = JSON.parse(dataEl.textContent);
    const form = $('form[data-product-form]', root);
    const idInput = $('input[name="id"]', form);

    const currentOptions = () => $$('[data-option-index]', root).map((fs) => {
      const c = $('input:checked', fs); return c ? c.value : null;
    });
    const findVariant = (opts) => product.variants.find((v) => v.options.every((o, i) => o === opts[i]));

    const fallback = parseInt(root.dataset.compareFallback || '0', 10) || 0;
    const cmpOf = (v) => (v.compare_at_price > v.price ? v.compare_at_price : (fallback > v.price ? fallback : 0));
    const setPrice = (v) => {
      $$('[data-price-now]', root).forEach((el) => (el.textContent = formatMoney(v.price)));
      const cmp = cmpOf(v), sale = cmp > 0;
      $$('[data-price-was]', root).forEach((el) => { el.textContent = sale ? formatMoney(cmp) : ''; el.hidden = !sale; });
      $$('[data-offer-tag]', root).forEach((el) => { el.hidden = !sale; const b = $('[data-offer-pct]', el); if (b && sale) b.textContent = `-${Math.round((1 - v.price / cmp) * 100)}%`; });
      $$('[data-price-save]', root).forEach((el) => { el.hidden = !sale; if (sale) el.textContent = el.dataset.template.replace('[amount]', formatMoney(cmp - v.price)); });
      $$('.product__price, .sticky-buy .price', root).forEach((p) => p.classList.toggle('price--sale', sale));
    };

    const setAvailability = (v) => {
      $$('[data-add-button]', root).forEach((b) => {
        b.disabled = !v || !v.available;
        const label = $('[data-label]', b);
        if (label) label.textContent = !v ? E.strings.unavailable : v.available ? b.dataset.labelDefault : E.strings.soldOut;
      });
    };


    root.addEventListener('change', (e) => {
      if (!e.target.closest('[data-option-index]')) return;
      const opts = currentOptions();
      $$('[data-option-index]', root).forEach((fs, idx) => {
        const legendVal = $('[data-selected-value]', fs); if (legendVal) legendVal.textContent = opts[idx];
      });
      const v = findVariant(opts);
      setAvailability(v);
      if (!v) return;
      idInput.value = v.id;
      setPrice(v);
      if (v.featured_media) goToMedia(v.featured_media.id);
      const url = new URL(window.location.href); url.searchParams.set('variant', v.id);
      history.replaceState({}, '', url);
    });

    // Galería
    const track = $('.gallery__track', root);
    const slides = track ? $$('.gallery__slide', track) : [];
    const dots = $$('.gallery__dot', root), thumbs = $$('.gallery__thumb', root);
    const counter = $('[data-gallery-counter]', root);
    const setActive = (i) => {
      dots.forEach((d, k) => d.classList.toggle('is-active', k === i));
      thumbs.forEach((t, k) => t.classList.toggle('is-active', k === i));
      if (counter) counter.textContent = `${i + 1} / ${slides.length}`;
    };
    const goTo = (i) => { if (!track) return; track.scrollTo({ left: slides[i].offsetLeft, behavior: reduceMotion ? 'auto' : 'smooth' }); setActive(i); };
    const goToMedia = (mediaId) => { const i = slides.findIndex((s) => s.dataset.mediaId == mediaId); if (i > -1) goTo(i); };
    if (track) {
      let raf;
      track.addEventListener('scroll', () => { cancelAnimationFrame(raf); raf = requestAnimationFrame(() => setActive(Math.round(track.scrollLeft / track.clientWidth))); }, { passive: true });
      thumbs.forEach((t, i) => t.addEventListener('click', () => goTo(i)));
      dots.forEach((d, i) => d.addEventListener('click', () => goTo(i)));
    }

    // Barra fija de compra
    const sticky = $('.sticky-buy', root), mainBtn = $('[data-main-buy]', root);
    if (sticky && mainBtn && 'IntersectionObserver' in window) {
      const io = new IntersectionObserver(([e]) => {
        sticky.classList.toggle('is-visible', !e.isIntersecting);
      });
      io.observe(mainBtn.closest(".buy") || mainBtn);
      $('[data-sticky-submit]', sticky)?.addEventListener('click', () => mainBtn.click());
    }


    // Oferta con fecha de fin (cuenta atrás real)
    $$('[data-countdown]', root).forEach((el) => {
      const end = parseInt(el.dataset.countdown, 10) * 1000;
      const pad = (n) => String(n).padStart(2, '0');
      const tick = () => {
        const left = Math.max(0, end - Date.now());
        if (left <= 0) { el.remove(); return; }
        const s = Math.floor(left / 1000);
        $('[data-cd-d]', el).textContent = Math.floor(s / 86400);
        $('[data-cd-h]', el).textContent = pad(Math.floor((s % 86400) / 3600));
        $('[data-cd-m]', el).textContent = pad(Math.floor((s % 3600) / 60));
        $('[data-cd-s]', el).textContent = pad(s % 60);
      };
      tick(); setInterval(tick, 1000);
    });

    // Hora límite diaria de preparación (hora de Madrid)
    const cutoff = $('[data-cutoff]', root);
    if (cutoff) {
      const hour = parseInt(cutoff.dataset.cutoff, 10), weekend = cutoff.dataset.weekend === 'true';
      const out = $('[data-cutoff-left]', cutoff);
      const madridNow = () => {
        const p = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Madrid', hour12: false, weekday: 'short', hour: '2-digit', minute: '2-digit', second: '2-digit' }).formatToParts(new Date());
        const g = (t) => p.find((x) => x.type === t).value;
        return { day: g('weekday'), secs: (parseInt(g('hour'), 10) % 24) * 3600 + parseInt(g('minute'), 10) * 60 + parseInt(g('second'), 10) };
      };
      const tick = () => {
        const n = madridNow();
        const isWeekend = n.day === 'Sat' || n.day === 'Sun';
        const left = hour * 3600 - n.secs;
        if (left <= 0 || (isWeekend && !weekend)) { cutoff.hidden = true; return; }
        cutoff.hidden = false;
        const h = Math.floor(left / 3600), m = Math.floor((left % 3600) / 60);
        out.textContent = h > 0 ? `${h} h ${m} min` : `${m} min`;
      };
      tick(); setInterval(tick, 30000);
    }

    // Fechas estimadas de entrega (hora de Madrid, mismo reloj que el aviso de hora límite)
    const delivery = $('[data-delivery]', root);
    if (delivery) {
      const madrid = () => {
        const p = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Madrid', hour12: false, year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' }).formatToParts(new Date());
        const g = (t) => parseInt(p.find((x) => x.type === t).value, 10);
        return { y: g('year'), m: g('month'), d: g('day'), secs: (g('hour') % 24) * 3600 + g('minute') * 60 + g('second') };
      };
      const isBiz = (d) => d.getUTCDay() !== 0 && d.getUTCDay() !== 6;
      const addBiz = (d, n) => { const r = new Date(d); let k = 0; while (k < n) { r.setUTCDate(r.getUTCDate() + 1); if (isBiz(r)) k++; } return r; };
      const WD = ['dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb'], WDL = ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'];
      const MS = ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'];
      const ML = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'];
      const day = (d) => `${WD[d.getUTCDay()]} ${d.getUTCDate()} ${MS[d.getUTCMonth()]}`;
      // intervalo sin repetir mes: «27–29 oct» o «30 oct – 2 nov»
      const range = (a, b) => (a.getUTCMonth() === b.getUTCMonth()
        ? `${a.getUTCDate()}–${b.getUTCDate()} ${MS[a.getUTCMonth()]}`
        : `${a.getUTCDate()} ${MS[a.getUTCMonth()]} – ${b.getUTCDate()} ${MS[b.getUTCMonth()]}`);
      // «martes 27 y jueves 29 de octubre» o «viernes 30 de octubre y lunes 2 de noviembre»
      const long = (a, b) => (a.getUTCMonth() === b.getUTCMonth()
        ? `${WDL[a.getUTCDay()]} ${a.getUTCDate()} y el ${WDL[b.getUTCDay()]} ${b.getUTCDate()} de ${ML[b.getUTCMonth()]}`
        : `${WDL[a.getUTCDay()]} ${a.getUTCDate()} de ${ML[a.getUTCMonth()]} y el ${WDL[b.getUTCDay()]} ${b.getUTCDate()} de ${ML[b.getUTCMonth()]}`);
      const now = madrid();
      const today = new Date(Date.UTC(now.y, now.m - 1, now.d));
      const cutoffEl = $('[data-cutoff]', root);
      const hour = cutoffEl ? parseInt(cutoffEl.dataset.cutoff, 10) : 14;
      // sale hoy si se pide en día laborable antes de la hora límite; si no, el siguiente día laborable
      const ship = isBiz(today) && now.secs < hour * 3600 ? today : addBiz(today, 1);
      const min = parseInt(delivery.dataset.min, 10), max = parseInt(delivery.dataset.max, 10);
      const from = addBiz(ship, min), to = addBiz(ship, max);
      $('[data-d-today]', delivery).textContent = day(today);
      // «Lo enviamos»: hoy si sale hoy; si no, el día siguiente (con asterisco si hoy o ese día son fin de semana)
      const tomorrow = new Date(today); tomorrow.setUTCDate(tomorrow.getUTCDate() + 1);
      const sameDay = ship.getTime() === today.getTime();
      const star = !sameDay && (!isBiz(today) || !isBiz(tomorrow));
      $('[data-d-ship]', delivery).textContent = sameDay ? 'hoy' : day(tomorrow) + (star ? '*' : '');
      $('[data-d-range]', delivery).textContent = range(from, to);
      const note = $('[data-d-note]', delivery); if (note) note.textContent = long(from, to);
    }
  };


  /* ---------- Banner principal ---------- */
  const initSlideshow = (root) => {
    const track = $('[data-track]', root); if (!track) return;
    const slides = $$('.slide', track), dots = $$('[data-dot]', root);
    const delay = (parseInt(root.dataset.autoplay, 10) || 6) * 1000;
    let index = 0, timer, paused = false;
    const setActive = (i) => {
      index = i;
      slides.forEach((s, k) => s.classList.toggle('is-active', k === i));
      dots.forEach((d, k) => {
        d.classList.toggle('is-done', k < i);
        d.classList.remove('is-active'); void d.offsetWidth;
        if (k === i) d.classList.add('is-active');
      });
      const dark = slides[i].classList.contains('slide--dark');
      root.classList.toggle('is-dark-slide', dark);
    };
    const go = (i) => { const n = (i + slides.length) % slides.length; track.scrollTo({ left: slides[n].offsetLeft, behavior: reduceMotion ? 'auto' : 'smooth' }); setActive(n); schedule(); };
    const schedule = () => { clearTimeout(timer); if (!paused && slides.length > 1 && !reduceMotion) timer = setTimeout(() => go(index + 1), delay); };
    let raf;
    track.addEventListener('scroll', () => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => { const i = Math.round(track.scrollLeft / track.clientWidth); if (i !== index) { setActive(i); schedule(); } });
    }, { passive: true });
    const pause = (v) => { paused = v; root.classList.toggle('is-paused', v); v ? clearTimeout(timer) : schedule(); };
    root.addEventListener('pointerenter', (e) => { if (e.pointerType === 'mouse') pause(true); });
    root.addEventListener('pointerleave', (e) => { if (e.pointerType === 'mouse') pause(false); });
    track.addEventListener('touchstart', () => pause(true), { passive: true });
    track.addEventListener('touchend', () => setTimeout(() => pause(false), 2500), { passive: true });
    document.addEventListener('visibilitychange', () => pause(document.hidden));
    $('[data-prev]', root)?.addEventListener('click', () => go(index - 1));
    $('[data-next]', root)?.addEventListener('click', () => go(index + 1));
    dots.forEach((d, i) => d.addEventListener('click', () => go(i)));
    setActive(0); schedule();
  };

  /* ---------- Búsqueda predictiva ---------- */
  const initSearch = () => {
    const input = $('#SearchInput'), out = $('#PredictiveResults');
    if (!input || !out) return;
    let timer, ctrl;
    input.addEventListener('input', () => {
      clearTimeout(timer);
      const q = input.value.trim();
      if (q.length < 2) { out.innerHTML = ''; return; }
      timer = setTimeout(async () => {
        ctrl && ctrl.abort(); ctrl = new AbortController();
        try {
          const res = await fetch(`${E.routes.search}.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=6`, { signal: ctrl.signal });
          const data = await res.json();
          const items = (data.resources.results.products || []);
          out.innerHTML = items.length ? items.map((p) => `
            <a href="${p.url}">${p.image ? `<img src="${p.image}&width=120" alt="" loading="lazy">` : '<span></span>'}
              <span><span class="predictive__title">${p.title}</span><br><span class="muted">${formatMoney(Math.round(parseFloat(p.price) * 100))}</span></span></a>`).join('')
            : `<p class="muted">Sin resultados para “${q.replace(/</g, '&lt;')}”.</p>`;
        } catch (_) { /* abortado */ }
      }, 220);
    });
  };

  /* ---------- Colección: filtros y orden ---------- */
  document.addEventListener('change', (e) => {
    const f = e.target.closest('form[data-auto-submit]');
    if (f) f.requestSubmit ? f.requestSubmit() : f.submit();
  });

  /* ---------- Init ---------- */
  /* ---------- Reseñas (carrusel) ---------- */
  const initReviews = (root) => {
    const track = $('[data-reviews-track]', root); if (!track) return;
    const cards = $$('.review', track); if (cards.length < 2) return;
    const mobile = window.matchMedia('(max-width: 989px)');
    const col = () => { const n = cards.find((c) => c.offsetLeft > cards[0].offsetLeft + 4); return n ? n.offsetLeft - cards[0].offsetLeft : track.clientWidth; };
    const step = () => (mobile.matches ? col() : col() * 3);
    const atEnd = () => track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
    let timer, paused = false;
    const next = () => track.scrollTo({ left: atEnd() ? 0 : track.scrollLeft + step(), behavior: reduceMotion ? 'auto' : 'smooth' });
    const prev = () => track.scrollTo({ left: track.scrollLeft <= 4 ? track.scrollWidth : track.scrollLeft - step(), behavior: reduceMotion ? 'auto' : 'smooth' });
    const schedule = () => { clearTimeout(timer); if (!paused && !reduceMotion) timer = setTimeout(() => { next(); schedule(); }, 5000); };
    const pause = (v) => { paused = v; v ? clearTimeout(timer) : schedule(); };
    $('[data-reviews-next]', root)?.addEventListener('click', () => { next(); schedule(); });
    $('[data-reviews-prev]', root)?.addEventListener('click', () => { prev(); schedule(); });
    root.addEventListener('pointerenter', (e) => { if (e.pointerType === 'mouse') pause(true); });
    root.addEventListener('pointerleave', (e) => { if (e.pointerType === 'mouse') pause(false); });
    track.addEventListener('touchstart', () => pause(true), { passive: true });
    track.addEventListener('touchend', () => setTimeout(() => pause(false), 2500), { passive: true });
    document.addEventListener('visibilitychange', () => pause(document.hidden));
    schedule();
  };

  const init = () => {
    initReveal();
    $$('[data-reviews]').forEach(initReviews);
    $$('[data-product]').forEach(initProduct);
    $$('[data-slideshow]').forEach(initSlideshow);
    initSearch();
  };
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', init) : init();
  document.addEventListener('shopify:section:load', (e) => { initReveal(e.target); $$('[data-product]', e.target).forEach(initProduct); $$('[data-slideshow]', e.target).forEach(initSlideshow); $$('[data-reviews]', e.target).forEach(initReviews); });
})();
